import React from "react";
import {
  Navbar,
  Collapse,
  Typography,
  Button,
  IconButton,
  List,
  ListItem,
  Menu,
  MenuHandler,
  MenuList,
  MenuItem,
} from "@material-tailwind/react";
import { IoClose, IoMenu } from "react-icons/io5";
import { Link, useLocation, useNavigate } from "react-router-dom";
import {
  decrypt,
  getEncodedCookie,
  LogOutSweetAlert,
  toAbsoluteUrl,
} from "../helpers/Reusable";
import { clearCookies, getCookie, setCookie } from "../helpers/CookieComponent";
import { useContactStore } from "../stores/contactStore";

const nestedMenuItems = [
  {
    to: "/personalinfo",
    title: "Personal Information",
  },
  {
    to: "/myaddress",
    title: "Address",
  },
  {
    to: "/mytaxidentification",
    title: "Tax Identification Number",
  },
  {
    to: "/changepassword",
    title: "Change Password",
  },
  {
    to: "/manageinterest",
    title: "Manage Interest",
  },
];

function ProductMenu() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [openNestedMenu, setopenNestedMenu] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const renderItems = nestedMenuItems.map(({ title }, key) => (
    <a href="/advisory" key={key}>
      <MenuItem>{title}</MenuItem>
    </a>
  ));
  const auth = decrypt(getCookie("token")) || "";
  const navigate = useNavigate();

  return (
    <React.Fragment>
      <Menu
        open={isMenuOpen}
        handler={setIsMenuOpen}
        placement="bottom"
        allowHover={true}
        className="w-[10%]"
      >
        <MenuHandler>
          <Typography as="div" variant="small" className="w-max">
            <ListItem
              className="flex items-center text-3xl gap-2 py-2 pr-4 h-menu-txt"
              selected={isMenuOpen || isMobileMenuOpen}
              onClick={() => {
                setIsMobileMenuOpen((cur) => !cur);
                if (auth) {
                  navigate("/product");
                }
              }}
            >
              Product
            </ListItem>
          </Typography>
        </MenuHandler>
        <MenuList className="z-[1112] hidden rounded-xl lg:block">
          <Menu
            placement="right-start"
            allowHover
            offset={15}
            open={openNestedMenu}
            handler={setopenNestedMenu}
          >
            <MenuHandler className="flex items-center justify-between h-menu-btn">
              <MenuItem className="h-menu-txt">
                <Link to="/advisory" className="w-full h-menu-txt">
                  Advisory
                </Link>
              </MenuItem>
            </MenuHandler>
            {/* <MenuList className="rounded-xl">{renderItems}</MenuList> */}
          </Menu>
          {/* <MenuItem className="h-menu-txt">Research report</MenuItem> */}
          <MenuItem className="h-menu-btn">
            <Link to="/readyreference" className="w-full h-menu-txt">
              Ready reference
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link to="/practice" className="w-full h-menu-txt">
              Practice
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link to="/books" className="w-full h-menu-txt">
              Books
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link to="/taxreturns" className="w-full h-menu-txt">
              Tax & returns
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link to="/training" className="w-full h-menu-txt">
              Training
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link to="/webinar" className="w-full h-menu-txt">
              Webinar
            </Link>
          </MenuItem>
        </MenuList>
      </Menu>
      <div className="block lg:hidden">
        <Collapse open={isMobileMenuOpen}>
          <MenuItem className="">
            <Link to="/advisory" className="w-full h-menu-txt">
              Advisory
            </Link>
          </MenuItem>
          {/* <MenuItem className="h-menu-txt">Research report</MenuItem> */}
          <MenuItem className="">
            <Link to="/readyreference" className="w-full h-menu-txt">
              Ready reference
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link to="/practice" className="w-full h-menu-txt">
              Practice
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link to="/books" className="w-full h-menu-txt">
              Books
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link to="/taxreturns" className="w-full h-menu-txt">
              Tax & returns
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link to="/training" className="w-full h-menu-txt">
              Training
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link to="/webinar" className="w-full h-menu-txt">
              Webinar
            </Link>
          </MenuItem>
        </Collapse>
      </div>
    </React.Fragment>
  );
}

function KnowledgeBase() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [openNestedMenu, setopenNestedMenu] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const renderItems = nestedMenuItems.map(({ title }, key) => (
    <a href="/advisory" key={key}>
      <MenuItem>{title}</MenuItem>
    </a>
  ));
  const contactList = useContactStore((state) => state.contactList);
  const youtube = contactList?.find((item) => item?.title === "You Tube");
  
  


  return (
    <React.Fragment>
      <Menu
        open={isMenuOpen}
        handler={setIsMenuOpen}
        placement="bottom"
        allowHover={true}
        className="w-[10%]"
      >
        <MenuHandler>
          <Typography as="div" variant="small" className="w-max">
            <ListItem
              className="flex items-center whitespace-nowrap text-3xl gap-2 py-2 pr-4 h-menu-txt"
              selected={isMenuOpen || isMobileMenuOpen}
              onClick={() => setIsMobileMenuOpen((cur) => !cur)}
            >
              Knowledge base
            </ListItem>
          </Typography>
        </MenuHandler>
        <MenuList className="z-[1112] hidden rounded-xl lg:block">
          <Menu
            placement="right-start"
            allowHover
            offset={15}
            open={openNestedMenu}
            handler={setopenNestedMenu}
          >
            <MenuHandler className="flex items-center justify-between h-menu-btn">
              <MenuItem>
                <Link
                  to="/articlelist"
                  onClick={() => setCookie("menu", "Article", {})}
                  className="w-full h-menu-txt"
                >
                  Article
                </Link>
              </MenuItem>
            </MenuHandler>
            {/* <MenuList className="rounded-xl">{renderItems}</MenuList> */}
          </Menu>
          <MenuItem className="h-menu-btn">
            <Link
              to="/articlelist"
              onClick={() => {
                setCookie("menu", "Presentation", {});
                setCookie("articleCategoryId", "", {});
              }}
              className="w-full h-menu-txt"
            >
              Presentations
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link
              to="/articlelist"
              onClick={() => {
                setCookie("menu", "Videos", {});
                setCookie("articleCategoryId", "", {});
              }}
              className="w-full h-menu-txt"
            >
              Videos
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link
              to="/articlelist"
              onClick={() => setCookie("menu", "Recent Question", {})}
              className="w-full h-menu-txt"
            >
              Queries
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <a
              target="_blank"
              // href="https://www.youtube.com/channel/UCXTG9LAJGUeiDHsE8NQBkAg"
              href={youtube?.detail}
              className="w-full h-menu-txt"
            >
              Youtube video
            </a>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link to="/latestupdate" className="w-full h-menu-txt">
              Latest update
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link to="/importantlinks" className="w-full h-menu-txt">
              Important links
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link to="/download" className="w-full h-menu-txt">
              Download
            </Link>
          </MenuItem>
        </MenuList>
      </Menu>
      <div className="block lg:hidden">
        <Collapse open={isMobileMenuOpen}>
          <MenuItem className="">
            <Link
              to="/articlelist"
              onClick={() => setCookie("menu", "Article", {})}
              className="w-full h-menu-txt"
            >
              Article
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link
              to="/articlelist"
              onClick={() => setCookie("menu", "Presentation", {})}
              className="w-full h-menu-txt"
            >
              Presentations
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link
              to="/articlelist"
              onClick={() => setCookie("menu", "Videos", {})}
              className="w-full h-menu-txt"
            >
              Videos
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link
              to="/articlelist"
              onClick={() => setCookie("menu", "Recent Question", {})}
              className="w-full h-menu-txt"
            >
              Queries
            </Link>
          </MenuItem>
          <MenuItem className="">
            <a
              target="_blank"
              href="https://www.youtube.com/channel/UCXTG9LAJGUeiDHsE8NQBkAg"
              className="w-full h-menu-txt"
            >
              Youtube video
            </a>
          </MenuItem>
          <MenuItem className="">
            <Link to="/latestupdate" className="w-full h-menu-txt">
              Latest Update
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link to="/importantlinks" className="w-full h-menu-txt">
              Important links
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link to="/download" className="w-full h-menu-txt">
              Download
            </Link>
          </MenuItem>
        </Collapse>
      </div>
    </React.Fragment>
  );
}

function ProfileMenu() {
  const [isMenuOpen, setIsMenuOpen] = React.useState(false);
  const [openNestedMenu, setopenNestedMenu] = React.useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  const renderItems = nestedMenuItems.map(({ title, to }, key) => (
    <Link className="h-menu-txt" to={to} key={key}>
      <MenuItem>{title}</MenuItem>
    </Link>
  ));
  const navigate = useNavigate();
  const location = useLocation();

  const isLogout = async () => {
    const result = await LogOutSweetAlert();
    if (result.isConfirmed) {
      clearCookies();
      setCookie("log-modal", true, {});
      navigate("/", { replace: true });
      document.location.reload();
    }
  };

  return (
    <React.Fragment>
      <Menu
        open={isMenuOpen}
        handler={setIsMenuOpen}
        placement="bottom"
        allowHover={true}
        className="w-[10%]"
      >
        <MenuHandler>
          <Typography as="div" variant="small" className="w-max">
            <ListItem
              className="flex items-center text-3xl gap-2 py-2 pr-4 h-menu-txt"
              selected={isMenuOpen || isMobileMenuOpen}
              onClick={() => setIsMobileMenuOpen((cur) => !cur)}
            >
              Profile
            </ListItem>
          </Typography>
        </MenuHandler>
        <MenuList className="z-[1112] hidden rounded-xl lg:block">
          <Menu
            placement="right-start"
            allowHover
            offset={15}
            open={openNestedMenu}
            handler={setopenNestedMenu}
          >
            <MenuHandler className="flex items-center justify-between h-menu-btn">
              <MenuItem className="h-menu-txt">
                <Link to="/myaccount" className="w-full h-menu-txt">
                  My Accounts
                </Link>
              </MenuItem>
            </MenuHandler>
            <MenuList className="z-[1113] rounded-xl">{renderItems}</MenuList>
          </Menu>
          <MenuItem className="h-menu-btn">
            <Link to="/mysubscription" className="w-full h-menu-txt">
              My Subscription
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link to="/myorder" className="w-full h-menu-txt">
              My Order
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link to="/mylibrary" className="w-full h-menu-txt">
              My Library
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link to="/referandearn" className="w-full h-menu-txt">
              Refer and Earn
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <Link to="/managenewsletter" className="w-full h-menu-txt">
              Manager Newsletter
            </Link>
          </MenuItem>
          <MenuItem className="h-menu-btn">
            <div
              role="button"
              onClick={() => isLogout()}
              className="w-full h-menu-txt"
            >
              Log out
            </div>
          </MenuItem>
        </MenuList>
      </Menu>
      <div className="block lg:hidden">
        <Collapse open={isMobileMenuOpen}>
          {/* <MenuItem className="">
            <Link to="/advisory" className="w-full h-menu-txt">
              My Accounts
            </Link>
          </MenuItem> */}
          <MenuItem>
            <details>
              <summary className="cursor-pointer w-full h-menu-txt [&::-webkit-details-marker]:hidden [&::marker]:hidden">
                My Accounts
                {/* <Link to="/myaccount" className="w-full">
                   My Accounts
                </Link> */}
              </summary>
              <div className="ml-4 mt-2 space-y-2">
                {nestedMenuItems.map(({ title, to }, key) => (
                  <Link to={to} key={key} className="block  h-menu-txt">
                    {title}
                  </Link>
                ))}
              </div>
            </details>
          </MenuItem>

          <MenuItem className="">
            <Link to="/mysubscription" className="w-full h-menu-txt">
              My Subscription
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link to="/myorder" className="w-full h-menu-txt">
              My Order
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link to="/mylibrary" className="w-full h-menu-txt">
              My Library
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link to="/referandearn" className="w-full h-menu-txt">
              Refer and Earn
            </Link>
          </MenuItem>
          <MenuItem className="">
            <Link to="/managenewsletter" className="w-full h-menu-txt">
              Manager Newsletter
            </Link>
          </MenuItem>
          <MenuItem className="">
            <div
              role="button"
              onClick={() => isLogout()}
              className="w-full h-menu-txt"
            >
              Log out
            </div>
          </MenuItem>
        </Collapse>
      </div>
    </React.Fragment>
  );
}

function NavList() {
  const auth = decrypt(getCookie("token")) || "";

  return (
    <List className="gap-5 lg:gap-[10%] w-full mb-6 mt-4 p-5 lg:mb-0 lg:mt-0 lg:flex-row lg:p-1">
      <Menu>
        <MenuHandler>
          <Typography as="div" variant="small" className="w-max">
            <Link to="/home">
              <ListItem className="flex items-center text-3xl gap-2 py-2 pr-4 h-menu-txt">
                Home
              </ListItem>
            </Link>
          </Typography>
        </MenuHandler>
      </Menu>
      <KnowledgeBase />
      <ProductMenu />
      {auth ? (
        <ProfileMenu />
      ) : (
        <Menu>
          <MenuHandler>
            <Typography as="div" variant="small" className="w-max">
              <Link to="/login">
                <ListItem className="flex items-center text-3xl gap-2 py-2 pr-4 h-menu-txt">
                  Login
                </ListItem>
              </Link>
            </Typography>
          </MenuHandler>
        </Menu>
      )}
    </List>
  );
}

export function NavigationbarWithDropdownMultilevelMenu() {
  const [openNav, setOpenNav] = React.useState(false);

  React.useEffect(() => {
    window.addEventListener(
      "resize",
      () => window.innerWidth >= 960 && setOpenNav(false)
    );
  }, []);

  return (
    <div className="w-full relative z-[1111] bg-white">
      {/* <div className="w-[90%] lg:w-[70%] mx-auto">
        <img
          className="mx-auto lg:mx-0 w-[20rem]"
          src={toAbsoluteUrl("media/img/logo/link-logo_2.png")}
          alt="GCC Law Help Logo"
        />
      </div> */}
      <Navbar className="w-full max-w-none navbar px-4 py-[1.5rem]">
        <div className="w-[90%] lg:w-[70%] mx-auto flex items-center justify-between lg:justify-normal gap-10 xl:gap-40">
          <Typography
            as="a"
            href="#"
            variant="h6"
            className="flex mr-4 cursor-pointer py-1.5 lg:ml-2"
          >
            <div className="w-max mx-auto">
              <img
                className="mx-auto lg:mx-0 w-[17rem] lg:w-[18rem]"
                src={toAbsoluteUrl("media/img/logo/link-logo_3.png")}
                alt="GCC Law Help Logo"
              />
            </div>
            <div className="w-[5rem] mx-auto lg:w-[5.5rem]">
              <img
                className="w-full"
                src={toAbsoluteUrl("media/img/logo/main-logo.svg")}
                alt="GCC Law Help Logo"
              />
            </div>
          </Typography>
          <div className="w-full hidden lg:block">
            <NavList />
          </div>
          <IconButton
            variant="text"
            className="lg:hidden"
            onClick={() => setOpenNav(!openNav)}
          >
            {openNav === false ? (
              <IoMenu className="w-[3rem] h-[3rem] cursor-pointer menu-icon" />
            ) : (
              <IoClose className="w-[3rem] h-[3rem] cursor-pointer menu-icon" />
            )}
          </IconButton>
        </div>
        <Collapse open={openNav}>
          <NavList />
        </Collapse>
      </Navbar>
    </div>
  );
}

//???????????????????????????????????????????????????????????????????
// import React from "react";

// const Header = () => {
//   return (
//     <div className="space-y-4">
//       {/* Hover Trigger Menu */}
//       <div className="relative group">
//         <button className="btn btn-light">Hover Trigger</button>
//         <div className="hidden group-hover:block absolute w-48 py-2 bg-white shadow-md rounded-md">
//           <div className="menu-item">
//             <a
//               href="#"
//               className="flex items-center px-4 py-2 hover:bg-gray-100"
//             >
//               <span className="menu-icon mr-2">
//                 <i className="ki-outline ki-badge"></i>
//               </span>
//               <span className="menu-title">Submenu item 1</span>
//             </a>
//           </div>
//           <div className="menu-item">
//             <a
//               href="#"
//               className="flex items-center px-4 py-2 hover:bg-gray-100"
//             >
//               <span className="menu-icon mr-2">
//                 <i className="ki-outline ki-profile-circle"></i>
//               </span>
//               <span className="menu-title">Submenu item 2</span>
//             </a>
//           </div>
//           <div className="menu-item">
//             <a
//               href="#"
//               className="flex items-center px-4 py-2 hover:bg-gray-100"
//             >
//               <span className="menu-icon mr-2">
//                 <i className="ki-outline ki-coffee"></i>
//               </span>
//               <span className="menu-title">Submenu item 3</span>
//             </a>
//           </div>
//         </div>
//       </div>

//       {/* Click Trigger Menu */}
//       <div className="relative">
//         <button
//           className="btn btn-light"
//           onClick={(e) => {
//             const dropdown = e.currentTarget.nextSibling;
//             dropdown.classList.toggle("hidden");
//           }}
//         >
//           Click Trigger
//         </button>
//         <div className="hidden absolute w-48 py-2 bg-white shadow-md rounded-md">
//           <div className="menu-item">
//             <a
//               href="#"
//               className="flex items-center px-4 py-2 hover:bg-gray-100"
//             >
//               <span className="menu-icon mr-2">
//                 <i className="ki-outline ki-badge"></i>
//               </span>
//               <span className="menu-title">Submenu item 1</span>
//             </a>
//           </div>
//           <div className="menu-item">
//             <a
//               href="#"
//               className="flex items-center px-4 py-2 hover:bg-gray-100"
//             >
//               <span className="menu-icon mr-2">
//                 <i className="ki-outline ki-profile-circle"></i>
//               </span>
//               <span className="menu-title">Submenu item 2</span>
//             </a>
//           </div>
//           <div className="menu-item">
//             <a
//               href="#"
//               className="flex items-center px-4 py-2 hover:bg-gray-100"
//             >
//               <span className="menu-icon mr-2">
//                 <i className="ki-outline ki-coffee"></i>
//               </span>
//               <span className="menu-title">Submenu item 3</span>
//             </a>
//           </div>
//         </div>
//       </div>
//     </div>
//   );
// };

// export default Header;
